import React, { useState, useRef, useEffect } from 'react';

import {
	menuItems,
	TabSubItems,
	TeamItems,
	PateintData,
	FormsData,
	compoundItems,
	InvoiceItems,
	ARVItems,
	RevenueItems,
	FdaFormsItems,
	AddTravelItems,
	AppItems,
	VccineItems
	
} from '../../../constants/workspace';

import {
	useCustomDispatch,
	useCustomNavigate
} from '../../../hooks';

import { useCustomSelectors } from '../../../services/selectors/allSelectors';
import { useCommonReducerSelector } from '../../../services/selectors/commonReducerSelector';
import { FetchTotalIncomingOrdersCount } from '../../../services/reducers/pharmacy/pacaking/packaging';
import useFulfilmentConfig from '../../../hooks/useFulfilmentConfig';
import useMyModules, { buildModuleGate, refreshMyModules } from '../../../hooks/useMyModules';
import { useAdminStealthHidden } from '../../../hooks/useAdminStealth';
import usePharmacyFeatureFlags from '../../../hooks/usePharmacyFeatureFlags';
import useSuperNovaAccess from '../../../hooks/useSuperNovaAccess';
import { navItemAllowed } from '../../../constants/moduleSubItems';

import * as routeNames from '../../../routes/routeName';

const DropdownMenu = () => {

	const scrollContainerRef = useRef(null);
	const [showLeftArrow, setShowLeftArrow] = useState(false);
	const [showRightArrow, setShowRightArrow] = useState(false);
	const [activePackaging, setActivePackaging] = useState(false)
	const [dropdownVisible, setDropdownVisible] = useState(false);
	const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
	const [dropdownItems, setDropdownItems] = useState([]);
	const [ordersCount, setOrdersCount] = useState(null)
	const [activeWorkTabs, setActiveWorkTabs] = useState(Number(sessionStorage.getItem('work_tab')));
	const navigate = useCustomNavigate();
	const dispatch = useCustomDispatch()

	const { pharmacyLoginUser,
		pharmacyLoginData,
		adminModule,
		pharmacyId,
		profileData,
		accountabilitySettings,
		showAfterProcessPrepCheck,
		bookkeeperModuleAccess,
		oat_sheet_enable,
		teamStatus } = useCustomSelectors();


	
	const { checkLogsExistsData } = useCommonReducerSelector();
	const superNovaAccess = useSuperNovaAccess({
		adminModule,
		oatSheetEnabled: oat_sheet_enable,
	});
	// ADMIN SCREEN PRIVACY (F9 x5, see useAdminStealth). The pharmacist-only
	// nav entries are role entries just like the admin ones, so they hide with
	// them: while hidden this reads false and every check below draws the menu
	// an ordinary team member sees. Deliberately scoped to NAV VISIBILITY --
	// profileData.type itself is untouched, so pharmacist logic elsewhere
	// (verification, video calls, signing) behaves exactly as it does today.
	// `adminStealthHidden` is false for every non-admin and false whenever the
	// backend cannot answer, so this is a no-op for everybody else.
	const adminStealthHidden = useAdminStealthHidden();
	const isPharmacistUser = profileData?.type === 'pharmacist' && !adminStealthHidden;

	// A pharmacy that packs its own orders needs its module's files page too, so the
	// nav can no longer show "My PACMed Files" / "My Files" to the hubs alone. The
	// hub ids stay hard-coded below on purpose: Weldon's and Prosper's entries must
	// not depend on this request succeeding — the config only ADDS the self-fulfil
	// case, it never decides the hub case.
	const { pacmedMode, blisterMode } = useFulfilmentConfig();
	const selfFulfilsPacmed = pacmedMode === 'self';
	const selfFulfilsBlister = blisterMode === 'self';

	// New module-permission system. FAIL-OPEN: myModules is null whenever the
	// backend cannot answer (old backend, 500, network) and the checks below
	// then always pass, leaving the legacy permission logic to decide alone —
	// today's exact nav. When non-null they only RESTRICT.
	//
	// Permissions live on SUB-MODULES now, so:
	//   moduleAllowsTab  — the tab is DERIVED: it renders when the user holds
	//                      at least one of its sub-items.
	//   moduleAllowsItem — each sub-item renders only if its own key is held.
	// The legacy profile flags are used only if my-modules cannot answer. Once it
	// does answer, it is the authoritative source; requiring both would hide a
	// module that was granted through the new sub-module assignment system.
	const myModules = useMyModules();
	const featureFlags = usePharmacyFeatureFlags(pharmacyLoginData?.app_mode);
	const { legacy: isLegacyModuleResponse, hasKey, tabAllowed: moduleAllowsTab } = buildModuleGate(myModules);
	const moduleAllowsItem = (route) => navItemAllowed(route, hasKey);

	const userPermissions = {
		'PATIENTS': { id: 1, permission: pharmacyLoginUser?.pharmacy_patient, route: routeNames.ALL_PATIENTS,routes:PateintData },
		'FORMS': { id: 2, permission: pharmacyLoginUser?.pharmacy_forms, route: routeNames.PHARMACY_INFORMATION_UPDATE_FORM,routes:FormsData },
		'COMPOUND': { id: 4, permission: pharmacyLoginUser?.pharmacy_compounds, route: routeNames.pharmacy_order_compounding_form,routes:compoundItems },
		'BLISTERS': { id: 5, permission: pharmacyLoginUser?.pharmacy_blister, hasDropdown: true },
		'ARV': { id: 6, permission: pharmacyLoginUser?.pharmacy_arv, route: routeNames.ADD_ARV,routes:ARVItems },
		'VIALS': { id: 7, permission: pharmacyLoginUser?.pharmacy_vials, hasDropdown: true },
		'SPECIALITY MEDICATION': { id: 8, permission: pharmacyLoginUser?.pharmacy_speciality_medication, hasDropdown: true },
		'REVENUE': { id: 9, permission: pharmacyLoginUser?.pharmacy_revinue_management, route: routeNames.pharmacy_daily_revenue,routes:RevenueItems },
		'DISPENSE': { id: 10, permission: pharmacyLoginUser?.pharmacy_daily_dispense, hasDropdown: true },
		'FDA FORM': { id: 11, permission: pharmacyLoginUser?.pharmacy_fda, route: routeNames.create_new_fda_form ,routes:FdaFormsItems},
		'DOCTOR': { id: 12, permission: pharmacyLoginUser?.pharmacy_doctor_integration },
		'INVOICE': { id: 13, permission: 'INVOICE', route: routeNames.pharmacy_generate_invoice,routes:InvoiceItems },
		'INVENTORY': { id: 14, permission: 'INVENTORY', hasDropdown: true },
		'ACCOUNTABILITY': { id: 21, permission: 'ACCOUNTABILITY', hasDropdown: true },
		'TRAVEL': { id: 15, permission: 'TRAVEL', route: routeNames.pharmacy_add_travel_pack,routes:AddTravelItems },
		'VACCINE': { id: 19, permission: 'VACCINE', route: routeNames.pharmacy_vaccine_passport ,routes:VccineItems},
		'PACKAGING': { id: 18, permission: 'PACKAGING', hasDropdown: true },
		'APP': { id: 16, permission: pharmacyLoginData?.app_mode === 1 && 'APP', route: routeNames.pharmacy_order_transfer, routes: AppItems },
	...(adminModule === 1 ? { 'TEAM': { id: 17, permission:  'TEAM', route: routeNames.pharmacy_timeoff,routes:TeamItems } } : {})
	};

	useEffect(() => {
		const currentPath = window.location.pathname;
		const currentSearch = window.location.search;
		// Generic logic for all tabs (including dropdowns)
		const activeTab = Object.entries(userPermissions).find(([key, value]) => {
		    const currentroutes= currentPath.split('?')[0]
			if(currentroutes === value.route){
				if(value.routes && Array.isArray(value.routes)){
					return value.routes.some(itemroute => {
						return itemroute.route.split('?')[0] === currentroutes;
					});
				}
			}
		
			if (value.hasDropdown) {
				return TabSubItems[key]?.some(subItem => {
					if (!subItem.route) return false;
					if (subItem.route === routeNames.pharmacy_driver_clinic_call_logs && !isPharmacistUser) return false;
					const [subItemPath, subItemQuery] = subItem.route.split('?');
					const currentPathOnly = currentPath;
					const currentQuery = currentSearch.replace(/^\?/, '');
					if (subItemQuery) {
						return subItemPath === currentPathOnly && currentQuery.includes(subItemQuery);
					} else {
						return subItemPath === currentPathOnly;
					}
				});
			}
			if (!value.route) return false;
			 // If multiple subroutes are defined
			 if (value.routes && Array.isArray(value.routes)) {
				return value.routes.some(itemroute => {
					const [tabPath, tabQuery] = itemroute.route.split('?');
					const currentPathOnly = currentPath;
					const currentQuery = currentSearch.replace(/^\?/, '');
					if (tabQuery) {
						return (tabPath === currentPathOnly || currentPathOnly.startsWith(tabPath + '/')) && currentQuery.includes(tabQuery);
					} else {
						return tabPath === currentPathOnly || currentPathOnly.startsWith(tabPath + '/');
					}
				});
			}
			const [tabPath, tabQuery] = value.route.split('?');
			const currentPathOnly = currentPath;
			const currentQuery = currentSearch.replace(/^\?/, '');
			if (tabQuery) {
				return tabPath === currentPathOnly && currentQuery.includes(tabQuery);
			} else {
				return currentPathOnly.startsWith(tabPath);
			}
		});

		if (activeTab) {
			const [key, value] = activeTab;

			setActiveWorkTabs(value.id);
			sessionStorage.setItem('work_tab', value.id);
		} else {
			// If no matching route found, clear active tab
			setActiveWorkTabs(null);
			sessionStorage.removeItem('work_tab');
		}
	}, [window.location.pathname, window.location.search]);

	const getDropdownItems = (listitem, currentSuperNovaAccess) => {
		// Sub-module gate FIRST, so every hard-coded condition below still runs
		// on top of it (they can only ever hide more, never reveal).
		// A group header (PACMed / Blister) stays if the user holds the header's
		// key or any of the pages under it.
		let items = (TabSubItems[listitem] || []).filter(item =>
			moduleAllowsItem(item.route)
			|| (item.child || []).some(child => moduleAllowsItem(child.route))
		);

		// Filter items based on adminModule and pharmacyId for Book Keepers
		if (listitem === 'ACCOUNTABILITY') {
			items = items.filter(item => {
				if (item.name === 'BookKeeper' || item.name === 'Financials') {
					// Pharmacy ID 1502 always has access
					if (Number(pharmacyId) === 1502) {
						return adminModule === 1;
					}
					
					// Check has_access boolean from API response
					const hasAccess = bookkeeperModuleAccess?.data?.has_access || bookkeeperModuleAccess?.data?.hasAccountingAccess || false;
					
					// If has_access is true, current pharmacy can access Book Keepers
					return adminModule === 1 && hasAccess;
				}
				return true;
			});
		}

		// Filter "Med Review Logs V2" based on has_records from check-logs-exists API
		if (listitem === 'DISPENSE') {
			items = items.filter(item => {
				// Super Nova is an Admin-only workspace tab.
				if (item?.name === 'Super Nova') return (currentSuperNovaAccess.adminModule === 1 && currentSuperNovaAccess.oatSheetEnabled);
				if (item?.name === 'Half Baked') return adminModule === 1;
				if (item?.name === 'Mark Delivered') return Number(teamStatus) === 1;
				if (item?.route === routeNames.pharmacy_driver_clinic_call_logs) return isPharmacistUser;

				if (item.name === 'Med Review Logs V2') {
					// Show "Med Review Logs V2" only if has_records is true
					return checkLogsExistsData?.has_records === true;
				}
				return true;
			});
		}

		return items;
	};

	const showDropdown = (event, listitem) => {
		const rect = event.currentTarget.getBoundingClientRect();
		setDropdownPosition({ top: rect.bottom, left: rect.left });

		// Opening a menu is a display-only action. In particular, do not call the
		// Super Nova access endpoint while the user is only hovering Dispense.
		setDropdownItems(getDropdownItems(listitem, superNovaAccess));
		setDropdownVisible(true);
	};

	const hideDropdown = () => {
		setDropdownVisible(false);
	};

	useEffect(() => {
		// Check if scrolling is possible on mount and window resize
		const checkScrollability = () => {
			if (scrollContainerRef.current) {
				const { scrollWidth, clientWidth, scrollLeft } = scrollContainerRef.current;
				const canScroll = scrollWidth > clientWidth;
				setShowLeftArrow(scrollLeft > 0); // Show left arrow if scrolled
				setShowRightArrow(canScroll && scrollLeft < scrollWidth - clientWidth - 1); // Show right
			}
		};

		checkScrollability();
		const timeoutId = setTimeout(checkScrollability, 100);

		// Add resize listener
		window.addEventListener('resize', checkScrollability);

		return () => {
			window.removeEventListener('resize', checkScrollability);
			clearTimeout(timeoutId);
		};
	}, [menuItems, pharmacyLoginUser]);

	const handleScroll = () => {
		if (scrollContainerRef.current) {
			const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
			const canScroll = scrollWidth > clientWidth;

			if (!canScroll) {
				setShowLeftArrow(false);
				setShowRightArrow(false);
			} else {
				setShowLeftArrow(scrollLeft > 0);
				setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
			}
			sessionStorage.setItem('workspaceTabsScrollPosition', scrollLeft.toString());

			// Update dropdown position if visible
			if (dropdownVisible) {
				const activeButton = document.querySelector('.active');
				if (activeButton) {
					const rect = activeButton.getBoundingClientRect();
					setDropdownPosition({ top: rect.bottom, left: rect.left });
				}
			}
		}
		hideDropdown();
	};

	useEffect(() => {
		const savedScrollPosition = sessionStorage.getItem('workspaceTabsScrollPosition');
		if (savedScrollPosition && scrollContainerRef.current) {
			scrollContainerRef.current.scrollLeft = parseInt(savedScrollPosition);
		}
	}, []);

	const handlenNavigateSubItems = (route, index) => {
		const routeTabs = {
			DISPENSE: 10,
			BLISTERS: 5,
			VIALS: 7,
			"SPECIALITY MEDICATION": 8,
			INVENTORY: 14,
			"ACCOUNTABILITY": 21,
			PACKAGING: 18,
		};
		const workTab = Object.entries(routeTabs).find(([key]) =>
			TabSubItems[key].some(item => item.route === route)
		)?.[1] || index;

			setActiveWorkTabs(workTab);
			sessionStorage.setItem('work_tab', workTab);
			setActivePackaging(workTab === 18);

		setTimeout(() => {
			navigate(route);
		}, 100);
	};

	const handleSuperNovaNavigation = (route, index) => {
		// Validate access only when the user intentionally opens Super Nova.
		// The API remains the source of truth; if it denies access, stay on the
		// current page rather than navigating to the protected screen.
		superNovaAccess.refresh().then((currentSuperNovaAccess) => {
			const isAllowed = currentSuperNovaAccess.adminModule === 1
				&& currentSuperNovaAccess.oatSheetEnabled;

			if (!isAllowed) return;

			// A recently enabled Super Nova permission can leave the cached module
			// list stale. Refresh it only after the explicit Super Nova click.
			refreshMyModules();
			handlenNavigateSubItems(route, index);
		});
	};

	const handleNavigateChildItems = (route, index, event) => {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
		if (scrollContainerRef.current) {
			sessionStorage.setItem('workspaceTabsScrollPosition', scrollContainerRef.current.scrollLeft.toString());
		}

		const routeTabs = {
			DISPENSE: 10,
			BLISTERS: 5,
			VIALS: 7,
			"SPECIALITY MEDICATION": 8,
			INVENTORY: 14,
			"ACCOUNTABILITY": 21,
			PACKAGING: 18,
		};

		const workTab = Object.entries(routeTabs).find(([key]) =>
			TabSubItems[key]?.some(item =>
				item.child?.some(child => child.route === route)
			)
		)?.[1] || index;

		sessionStorage.setItem('work_tab', workTab);
		setActivePackaging(workTab === 18);
		setActiveWorkTabs(workTab);
		setTimeout(() => {
			navigate(route);
		}, 100);
	};

	const scroll = (direction) => {
		if (scrollContainerRef.current) {
			const container = scrollContainerRef.current;
			// Use the container's width as the scroll amount for a full-page scroll
			const scrollAmount = container.clientWidth;
			container.scrollBy({
				left: direction === 'left' ? -scrollAmount : scrollAmount,
				behavior: 'smooth'
			});
		}
	};

	const handleNavigateMenuItems = (route, index) => {

		if (['BLISTERS', 'VIALS', 'SPECIALITY MEDICATION', 'DISPENSE', 'INVENTORY', 'PACKAGING'].includes(route.name)) {
			return;
		} else {
			// Some parent tabs have more than one independently-permitted child.
			// Do not send a user to a hard-coded first child (for example ARV →
			// Add ARV) when that child is denied and a later child is allowed
			// (ARV → All ARV). This only chooses from routes the existing
			// sub-module gate already allows; it never grants anything new.
			const childRoute = (userPermissions[route.name]?.routes || [])
				.find((item) => moduleAllowsItem(item.route))?.route;
			const destination = childRoute || route.route;
			if (!destination) return;

			if (scrollContainerRef.current) {
				sessionStorage.setItem('workspaceTabsScrollPosition', scrollContainerRef.current.scrollLeft.toString());
			}
			sessionStorage.setItem('work_tab', index);
			navigate(destination);
		}
	};

	const handleSetActiveTab = (item, index) => {
		const childRoute = (userPermissions[item.name]?.routes || [])
			.find((child) => moduleAllowsItem(child.route))?.route;
		const destination = childRoute || item.route;
		if (!destination) return;

		if (scrollContainerRef.current) {
			sessionStorage.setItem('workspaceTabsScrollPosition', scrollContainerRef.current.scrollLeft.toString());
		}
		setActiveWorkTabs(index);
		sessionStorage.setItem('work_tab', index);
		navigate(destination);
	};

	const handleSetHoverActiveTab = (index) => {
		if (index === 18) {
			setActivePackaging(true)
		} else {
			setActivePackaging(false)
		}
	};

	React.useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);


	React.useEffect(() => {
		// if (pharmacyId === 1502 || pharmacyId === 865) {
		dispatch(FetchTotalIncomingOrdersCount({ setOrdersCount }))
		// }
	}, [pharmacyId])

	return (
		<div className=" bg-gray-700">
			<div className='container-fluid mx-auto px-2 flex  items-center gap-4'>
				<button
					onClick={() => scroll('left')}
					className={`bg-white text-gray-500 px-2 py-3 w-8  hover:bg-white flex justify-center items-center ${showLeftArrow ? 'block' : 'hidden'}`}
					style={{ height: '100%' }}>
					<span className='text-gray-500'>&#10094;</span>
				</button>

				<div
					ref={scrollContainerRef}
					onScroll={handleScroll}
					className=" px-2 overflow-auto listActive scroll-box dropscroll "
					style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
				>
					<ul
						className="flex items-center gap-0 justify-start whitespace-nowrap"
						aria-busy={false}
					>
						{menuItems?.map((item, index) => {
							const isActive = activeWorkTabs === userPermissions[item.name]?.id ||
								(userPermissions[item.name]?.hasDropdown && TabSubItems[item.name]?.some(subItem =>
									subItem.route === window.location.pathname ||
									subItem.child?.some(child => child.route === window.location.pathname)
								));

							const hasLegacyTabPermission = userPermissions[item.name]?.permission === item?.PermissionStatus;
							// App module assignment grants access only when the pharmacy's
							// App Mode is enabled.  `pharmacyLoginData` is populated from
							// the login response, so the portal uses the same feature flag
							// as the App routes below.  Other modules are unchanged.
							const hasRequiredFeature = item.name !== 'APP' || featureFlags.appMode;
							// Until the fresh backend answer arrives, moduleAllowsTab is
							// closed.  This deliberately renders no module tabs rather than
							// briefly exposing every legacy tab on a hard refresh.
							const canShowTab = hasRequiredFeature && (isLegacyModuleResponse
								? hasLegacyTabPermission
								: moduleAllowsTab(item.name));

							if (canShowTab) {
								return (
									<React.Fragment key={index}>
										<li
											className="relative flex-0"
											onClick={() => handleNavigateMenuItems(item, userPermissions[item.name]?.id)}
										>
											<div
												className="flex items-center"
												onMouseEnter={userPermissions[item.name]?.hasDropdown ? (e) => showDropdown(e, item.name) : null}
												onMouseLeave={userPermissions[item.name]?.hasDropdown ? hideDropdown : null}>

												<button
													onMouseEnter={() => handleSetHoverActiveTab(userPermissions[item.name]?.id)}
													onClick={() => handleSetActiveTab(item, userPermissions[item.name]?.id)}
													className={`${window.location.pathname === '/pharmacy-investigate-rx' ? '' : isActive ? "bg-white !text-black" : `hover:bg-gray-600`} cursor-pointer 
													px-3 py-3 fs-16  text-white-500 flex justify-center text-center  `}
													style={{ color: 'white', fontWeight: '500' }}>
													<span>{item.name}</span>
												</button>
											</div>
										</li>
									</React.Fragment>
								);
							}
							return null;
						})}

					</ul>
				</div>

				<button onClick={() => scroll('right')}
					className={`bg-white text-gray-500 px-2 py-3 w-8 hover:bg-white flex justify-center items-center ${showRightArrow ? 'block' : 'hidden'}`}
					style={{ height: '100%' }}>
					<span className='text-gray-500'>&#10095;</span>
				</button>
			</div>

			{dropdownVisible && (
				<div
					className="w-64 bg-gray-700 shadow-lg"
					style={{
						maxHeight: '400px',
						overflowY: activePackaging ? 'visible' : 'auto',
						position: 'fixed',
						top: `${dropdownPosition.top}px`,
						left: `${dropdownPosition.left}px`,
						zIndex: 9999
					}}
					onMouseEnter={() => setDropdownVisible(true)}
					onMouseLeave={hideDropdown}
				>
					<div className={`z-20 w-full max-w-sm bg-white divide-y divide-gray-100 shadow-md dark:bg-gray-800 dark:divide-gray-700  ${activePackaging ? '' : 'overflow-hidden'} `}>
						<div className="divide-y divide-gray-100 dark:divide-gray-700 " id="addlist">
							{dropdownItems?.sort((a, b) => {
								// Skip sorting if any item in dropdown is Accountability
								if (dropdownItems.some(item => (item.name === 'Accountability' || item.name === 'Billing' || item.name === 'Analytics'))) {
									return 0;
								}

								
								// For all other tabs, sort alphabetically
								return a.name.localeCompare(b.name);
							})?.map((item, index) => (
								<React.Fragment key={`${item.id}-${index}`}>
									{(adminModule === 0 && item.name === 'Delivery Drivers')
										|| ((profileData?.type !== 'pharmacist' || accountabilitySettings !== 'preparation') && item.name === 'Final Check')
										|| (item.name === 'Today Missed Rx' && profileData?.type !== 'pharmacist')
										|| (item.name === 'Accountability' && profileData?.type !== 'pharmacist')
										|| (item.route === routeNames.pharmacy_driver_clinic_call_logs && !isPharmacistUser)
										|| (item.name === 'ERx' && pharmacyId !== 1502)
										// || (item.name === 'After Process Prep Check' && !showAfterProcessPrepCheck)
										// || (item.name === 'Prep Check' && showAfterProcessPrepCheck)
										? null :

										item.name === 'Today Missed Rx'
											&& profileData?.type === 'pharmacist' && ordersCount?.today_pending_count === 0 ? null :

											<button
												onClick={() => item.name === 'Super Nova'
													? handleSuperNovaNavigation(item.route, activeWorkTabs)
													: handlenNavigateSubItems(item.route, activeWorkTabs)}
												className={`flex btnnn px-3 w-full py-3 hover:bg-gray-100 dark:hover:bg-gray-700  group ${activePackaging ? '' : 'overflow-hidden'} `}>
												<div className={`w-full ps-3 flex items-start ${activePackaging ? '' : 'overflow-hidden'} `}>
													<p className="text-gray-500 font-semibold text-sm  dark:text-gray-400 overflow-hidden text-ellipsis whitespace-nowrap ">
														{
															pharmacyId === 1502 && item.name === 'PACMed' ? (
																<>
																	PACMed
																	{ordersCount?.packaging_count > 0 && (
																		<span className='bg-red-500 text-white rounded-full px-2 py-0 ml-2'>
																			{ordersCount?.packaging_count}
																		</span>
																	)}
																</>
															) :
																pharmacyId === 865 && item.name === 'Blister' ? (
																	<>
																		Blister
																		{ordersCount?.blister_packaging_count > 0 && (
																			<span className='bg-red-500 text-white rounded-full px-2 py-0 ml-2'>
																				{ordersCount?.blister_packaging_count}
																			</span>
																		)}
																	</>
																) : (
																	item.name
																)
														}
													</p>
												</div>

												{item.child && (
													<ul className=" group-hover:block hidden   absolute top-0 left-[-300px] max-w-[300px] min-w-[300px]   bg-white shadow-md divide-y divide-gray-100 dark:divide-gray-700">
														{item.child.map((child, index) => (
															!moduleAllowsItem(child.route)
																|| (pharmacyId !== 1502 && !selfFulfilsPacmed && child.name === 'My PACMed Files')
																|| (!selfFulfilsPacmed && child.name === 'DIN Management')
																|| (adminModule === 0 && child.name === 'Invoice')
																|| (pharmacyId !== 865 && !selfFulfilsBlister && child.name === 'My Files')
																|| (pharmacyId === 1502 && child.name === 'Monthly Invoice' && item.name === 'Blister') 
																|| (pharmacyId !== 865 && pharmacyId !== 1502 && child.name === 'Monthly Invoice' )
																|| (pharmacyId === 865 && child.name === 'Monthly Invoice' && item.name === 'PACMed')
																||  (child.name === 'Monthly Invoice' && adminModule === 0)

																? null :
																(
																	<li
																		onClick={(e) => handleNavigateChildItems(child.route, activeWorkTabs, e)}
																		key={index} className='flex btnnn px-5 w-full py-3 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 font-semibold text-sm  dark:text-gray-400'>
																		{
																			pharmacyId === 1502 && child.name === 'Incoming Order' ? (
																				<>
																					Incoming Orders
																				</>
																			) : pharmacyId !== 1502 && child.name === 'Incoming Order' ? (
																				'All Orders'
																			) : pharmacyId === 865 && child.name === 'Incoming Orders' ? (
																				<>Incoming Orders</>
																			) : pharmacyId !== 865 && child.name === 'Incoming Orders' ? (
																				'All Orders'
																			) : (
																				child.name
																			)
																		}
																	</li>
																)
														))}
													</ul>
												)}
											</button>
									}
								</React.Fragment>
							))}
						</div>
					</div>
				</div>
			)
			}
		</div>
	);
};

export default DropdownMenu;



// Backup Code

// import React, { useState, useRef, useEffect } from 'react';
// import { menuItems, TabSubItems } from '../../../constants/workspace';
// import { useCustomDispatch, useCustomNavigate } from '../../../hooks';
// import { useCustomSelectors } from '../../../services/selectors/allSelectors';

// import * as routeNames from '../../../routes/routeName';
// import { FetchTotalIncomingOrdersCount } from '../../../services/reducers/pharmacy/pacaking/packaging';
// // import { usePackagingSelector } from '../../../services/selectors/pacakingSelector';

// const DropdownMenu = () => {

// 	const scrollContainerRef = useRef(null);
// 	const [showLeftArrow, setShowLeftArrow] = useState(false);
// 	const [showRightArrow, setShowRightArrow] = useState(false);

// 	const [dropdownVisible, setDropdownVisible] = useState(false);
// 	const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
// 	const [dropdownItems, setDropdownItems] = useState([]);

// 	const navigate = useCustomNavigate();
// 	const dispatch = useCustomDispatch()

// 	const { pharmacyLoginUser, pharmacyLoginData, adminModule, pharmacyId, profileData, accountabilitySettings } = useCustomSelectors();
// 	// const { fetchDashboardCountsResponse } = usePackagingSelector()

// 	const activeWorkTabs = Number(sessionStorage.getItem('work_tab'))

// 	useEffect(() => {
// 		const currentPath = window.location.pathname;
// 		const userPermissions = {
// 			'PATIENTS': { id: 1 },
// 			'FORMS': { id: 2 },
// 			'OAT': { id: 3 },
// 			'COMPOUND': { id: 4 },
// 			'BLISTERS': { id: 5 },
// 			'ARV': { id: 6 },
// 			'VIALS': { id: 7 },
// 			'SPECIALITY MEDICATION': { id: 8 },
// 			'REVENUE': { id: 9 },
// 			'DISPENSE': { id: 10 },
// 			'FDA FORM': { id: 11 },
// 			'DOCTOR': { id: 12 },
// 			'INVOICE': { id: 13 },
// 			'INVENTORY': { id: 14 },
// 			'TRAVEL': { id: 15 },
// 			'APP': { id: 16 },
// 			'TEAM': { id: 17 },
// 			'PACKAGING': { id: 18 },
// 			'VACCINE': { id: 19 },
// 			'BLISTER PACKAGING': { id: 20 },
// 			'ACCOUNTABILITY': { id: 21 },
// 		};

// 		menuItems.forEach(item => {
// 			if (item.route === currentPath) {
// 				sessionStorage.setItem('work_tab', userPermissions[item.name]?.id);
// 			}
// 		});
// 	}, [menuItems]);

// 	const showDropdown = (event, listitem) => {
// 		const rect = event.target.getBoundingClientRect();
// 		setDropdownPosition({ top: rect.bottom, left: rect.left });

// 		setDropdownItems(TabSubItems[listitem]);
// 		setDropdownVisible(true);
// 	};

// 	const hideDropdown = () => {
// 		setDropdownVisible(false);
// 	};

// 	// const handleScroll = () => {
// 	// 	hideDropdown();
// 	// };

// 	useEffect(() => {
// 		// Check if scrolling is possible on mount and window resize
// 		const checkScrollability = () => {
// 			if (scrollContainerRef.current) {
// 				const { scrollWidth, clientWidth, scrollLeft } = scrollContainerRef.current;
// 				const canScroll = scrollWidth > clientWidth;
// 				setShowLeftArrow(scrollLeft > 0); // Show left arrow if scrolled
// 				setShowRightArrow(canScroll && scrollLeft < scrollWidth - clientWidth - 1); // Show right
// 			}
// 		};

// 		checkScrollability();
// 		const timeoutId = setTimeout(checkScrollability, 100);

// 		// Add resize listener
// 		window.addEventListener('resize', checkScrollability);

// 		return () => {
// 			window.removeEventListener('resize', checkScrollability);
// 			clearTimeout(timeoutId);
// 		};
// 	}, [menuItems, pharmacyLoginUser]);

// 	const handleScroll = () => {
// 		if (scrollContainerRef.current) {
// 			const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
// 			const canScroll = scrollWidth > clientWidth;

// 			if (!canScroll) {
// 				setShowLeftArrow(false);
// 				setShowRightArrow(false);
// 			} else {
// 				setShowLeftArrow(scrollLeft > 0);
// 				setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
// 			}
// 			sessionStorage.setItem('workspaceTabsScrollPosition', scrollLeft.toString());

// 			// Update dropdown position if visible
// 			if (dropdownVisible) {
// 				const activeButton = document.querySelector('.active');
// 				if (activeButton) {
// 					const rect = activeButton.getBoundingClientRect();
// 					setDropdownPosition({ top: rect.bottom, left: rect.left });
// 				}
// 			}
// 		}
// 		hideDropdown();
// 	}

// 	useEffect(() => {
// 		const savedScrollPosition = sessionStorage.getItem('workspaceTabsScrollPosition');
// 		if (savedScrollPosition && scrollContainerRef.current) {
// 			scrollContainerRef.current.scrollLeft = parseInt(savedScrollPosition);
// 		}
// 	}, [])

// 	const handlenNavigateSubItems = (route, index) => {
// 		const routeTabs = {
// 			DISPENSE: 10,
// 			BLISTERS: 5,
// 			VIALS: 7,
// 			"SPECIALITY MEDICATION": 8,
// 			INVENTORY: 14,
// 			"ACCOUNTABILITY": 21,
// 			PACKAGING: 18,
// 			"BLISTER PACKAGING": 20,
// 		};
// 		const workTab = Object.entries(routeTabs).find(([key]) =>
// 			TabSubItems[key].some(item => item.route === route)
// 		)?.[1] || index;

// 		sessionStorage.setItem('work_tab', workTab);
// 		setTimeout(() => {
// 			navigate(route);
// 		}, 100);
// 	};



// 	const scroll = (direction) => {
// 		if (scrollContainerRef.current) {
// 			const container = scrollContainerRef.current;
// 			// Use the container's width as the scroll amount for a full-page scroll
// 			const scrollAmount = container.clientWidth;
// 			container.scrollBy({
// 				left: direction === 'left' ? -scrollAmount : scrollAmount,
// 				behavior: 'smooth'
// 			});
// 		}
// 	};

// 	const handleNavigateMenuItems = (route, index) => {
// 		if (['BLISTERS', 'VIALS', 'SPECIALITY MEDICATION', 'DISPENSE', 'INVENTORY'].includes(route.name)) {
// 			return;
// 		} else {
// 			if (scrollContainerRef.current) {
// 				sessionStorage.setItem('workspaceTabsScrollPosition', scrollContainerRef.current.scrollLeft.toString());
// 			}
// 			sessionStorage.setItem('work_tab', index);
// 			navigate(route.route);
// 		}
// 	};

// 	const handleSetActiveTab = (item, index) => {
// 		if (scrollContainerRef.current) {
// 			sessionStorage.setItem('workspaceTabsScrollPosition', scrollContainerRef.current.scrollLeft.toString());
// 		}
// 		sessionStorage.setItem('work_tab', index);
// 		navigate(item.route);
// 	};

// 	React.useEffect(() => {
// 		window.addEventListener('scroll', handleScroll);
// 		return () => {
// 			window.removeEventListener('scroll', handleScroll);
// 		};
// 	}, []);

// 	const [ordersCount, setOrdersCount] = useState(null)

// 	React.useEffect(() => {
// 		// if (pharmacyId === 1502 || pharmacyId === 865) {
// 		dispatch(FetchTotalIncomingOrdersCount({ setOrdersCount }))
// 		// }
// 	}, [pharmacyId])

// 	return (
// 		<div className=" bg-gray-700">


// 			<div className='container-fluid mx-auto px-2 flex justify-center items-center gap-4'>
// 				<button
// 					onClick={() => scroll('left')}
// 					className={`bg-white text-gray-500 px-2 py-3 w-8  hover:bg-white flex justify-center items-center ${showLeftArrow ? 'block' : 'hidden'}`}
// 					style={{ height: '100%' }}>
// 					<span className='text-gray-500'>&#10094;</span>
// 				</button>

// 				<div
// 					ref={scrollContainerRef}
// 					onScroll={handleScroll}
// 					className=" px-2 overflow-auto listActive scroll-box dropscroll "
// 					style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
// 				>
// 					<ul className="flex items-center gap-0 justify-start whitespace-nowrap ">
// 						{menuItems?.map((item, index) => {
// 							const userPermissions = {
// 								'PATIENTS': { id: 1, permission: pharmacyLoginUser?.pharmacy_patient, route: `${routeNames.ALL_PATIENTS}?status=1` },
// 								'FORMS': { id: 2, permission: pharmacyLoginUser?.pharmacy_forms, route: routeNames.PHARMACY_INFORMATION_UPDATE_FORM },
// 								'OAT': { id: 3, permission: pharmacyLoginUser?.pharmacy_oat },
// 								'COMPOUND': { id: 4, permission: pharmacyLoginUser?.pharmacy_compounds, route: routeNames.pharmacy_order_compounding_form },
// 								'BLISTERS': { id: 5, permission: pharmacyLoginUser?.pharmacy_blister, hasDropdown: true },
// 								'ARV': { id: 6, permission: pharmacyLoginUser?.pharmacy_arv, route: routeNames.ADD_ARV },
// 								'VIALS': { id: 7, permission: pharmacyLoginUser?.pharmacy_vials, hasDropdown: true },
// 								'SPECIALITY MEDICATION': { id: 8, permission: pharmacyLoginUser?.pharmacy_speciality_medication, hasDropdown: true },
// 								'REVENUE': { id: 9, permission: pharmacyLoginUser?.pharmacy_revinue_management, route: routeNames.pharmacy_daily_revenue },
// 								'DISPENSE': { id: 10, permission: pharmacyLoginUser?.pharmacy_daily_dispense, hasDropdown: true },
// 								'FDA FORM': { id: 11, permission: pharmacyLoginUser?.pharmacy_fda, route: routeNames.create_new_fda_form },
// 								'DOCTOR': { id: 12, permission: pharmacyLoginUser?.pharmacy_doctor_integration },
// 								'INVOICE': { id: 13, permission: 'INVOICE', route: routeNames.pharmacy_generate_invoice },
// 								'INVENTORY': { id: 14, permission: 'INVENTORY', hasDropdown: true },
// 								'ACCOUNTABILITY': { id: 21, permission: 'ACCOUNTABILITY', hasDropdown: true },
// 								'TRAVEL': { id: 15, permission: 'TRAVEL', route: routeNames.pharmacy_add_travel_pack },
// 								'VACCINE': { id: 19, permission: 'VACCINE', route: routeNames.pharmacy_add_travel_pack },
// 								'PACKAGING': { id: 18, permission: 'PACKAGING', hasDropdown: true },
// 								'BLISTER PACKAGING': { id: 20, permission: 'BLISTER PACKAGING', hasDropdown: true },
// 								'APP': { id: 16, permission: pharmacyLoginData?.app_mode === 1 && 'APP', route: routeNames.pharmacy_order_transfer },
// 								'TEAM': { id: 17, permission: adminModule === 1 && 'TEAM', route: routeNames.pharmacy_timeoff }
// 							};

// 							const isActive = activeWorkTabs === userPermissions[item.name]?.id

// 							if (userPermissions[item.name]?.permission === item?.PermissionStatus) {
// 								return (
// 									<React.Fragment key={index}>
// 										<li
// 											className="relative flex-0"
// 											onClick={() => handleNavigateMenuItems(item, userPermissions[item.name]?.id)}
// 										>
// 											<div
// 												className="flex items-center"
// 												onMouseOver={userPermissions[item.name]?.hasDropdown ? (e) => showDropdown(e, item.name) : null}
// 												onMouseOut={userPermissions[item.name]?.hasDropdown ? hideDropdown : null}
// 											>
// 												<button
// 													onClick={() => handleSetActiveTab(item, userPermissions[item.name]?.id)}
// 													className={`${isActive ? "active" : "hover:bg-gray-600"}  cursor-pointer
// 													px-3 py-3 fs-16  text-white-500 flex justify-center text-center`}
// 													style={{ color: 'white', fontWeight: '500' }}>
// 													{item.name}

// 													{ordersCount?.packaging_count > 0 && item.name === 'PACKAGING' && pharmacyId === 1502 && (
// 														<span
// 															className='bg-red-500 text-white rounded-full px-2 py-0 ml-2'
// 															onClick={(e) => e.stopPropagation()}
// 															onMouseOver={(e) => e.stopPropagation()}
// 														>
// 															{ordersCount?.packaging_count}
// 														</span>
// 													)}

// 													{ordersCount?.blister_packaging_count > 0 && item.name === 'BLISTER PACKAGING' && pharmacyId === 865 && (
// 														<span
// 															className='bg-red-500 text-white rounded-full px-2 py-0 ml-2'
// 															onClick={(e) => e.stopPropagation()}
// 															onMouseOver={(e) => e.stopPropagation()}
// 														>
// 															{ordersCount?.blister_packaging_count}
// 														</span>
// 													)}
// 												</button>
// 											</div>
// 										</li>
// 									</React.Fragment>
// 								);
//							}
// 							return null;
// 						})}

// 					</ul>
// 				</div>

// 				<button onClick={() => scroll('right')}
// 					className={`bg-white text-gray-500 px-2 py-3 w-8 hover:bg-white flex justify-center items-center ${showRightArrow ? 'block' : 'hidden'}`}
// 					style={{ height: '100%' }}>
// 					<span className='text-gray-500'>&#10095;</span>

// 				</button>

// 			</div>
// 			{dropdownVisible && (
// 				<div
// 					className="w-64 bg-gray-700 shadow-lg overflow-hidden"
// 					style={{
// 						maxHeight: '400px',
// 						overflowY: 'auto',
// 						position: 'fixed',
// 						top: `${dropdownPosition.top}px`,
// 						left: `${dropdownPosition.left}px`,
// 						zIndex: 9999
// 					}}
// 					onMouseEnter={() => setDropdownVisible(true)}
// 					onMouseLeave={hideDropdown}
// 				>
// 					<div className="z-20 w-full max-w-sm bg-white divide-y divide-gray-100 shadow-md dark:bg-gray-800 dark:divide-gray-700 overflow-hidden">
// 						<div className="divide-y divide-gray-100 dark:divide-gray-700 " id="addlist">
// 							{dropdownItems?.sort((a, b) => {
// 								// If both items are Accountability, don't sort them
// 								if (a.name === 'Accountability' && b.name === 'Accountability') return 0;
								
// 								// If first item is Accountability, keep it at top
// 								if (a.name === 'Accountability') return -1;
								
// 								// If second item is Accountability, keep it at top
// 								if (b.name === 'Accountability') return 1;
								
// 								// For all other items, sort alphabetically
// 								return a.name.localeCompare(b.name);
// 							})?.map((item, index) => (
// 								<React.Fragment key={`${item.id}-${index}`}>
// 									{(adminModule === 0 && item.name === 'Delivery Drivers')
// 										|| (pharmacyId !== 1502 && item.name === 'My PACMed Files')
// 										|| (pharmacyId !== 865 && item.name === 'My Files')
// 										|| ((profileData?.type !== 'pharmacist' || accountabilitySettings !== 'preparation') && item.name === 'Final Check')
// 										// || (item.name === 'Today Missed Rx' && profileData?.type !== 'pharmacist')
// 										? null :

// 										// item.name === 'Today Missed Rx'
// 										// 	&& profileData?.type === 'pharmacist' && ordersCount?.today_pending_count === 0 ? null :

// 										<button
// 											onClick={() => handlenNavigateSubItems(item.route, activeWorkTabs)}
// 											className="flex btnnn px-3 w-full py-2 hover:bg-gray-100 dark:hover:bg-gray-700 overflow-hidden">
// 											<div className="w-full ps-3 flex items-start overflow-hidden">
// 												<p className="text-gray-500 font-semibold text-sm mb-1.5 dark:text-gray-400 overflow-hidden text-ellipsis whitespace-nowrap">
// 													{
// 														pharmacyId === 1502 && item.name === 'Incoming Order' ? (
// 															<>
// 																Incoming Orders
// 																{ordersCount?.packaging_count > 0 && (
// 																	<span className='bg-red-500 text-white rounded-full px-2 py-0 ml-2'>
// 																		{ordersCount?.packaging_count}
// 																	</span>
// 																)}
// 															</>
// 														) : pharmacyId !== 1502 && item.name === 'Incoming Order' ? (
// 															'All Orders'
// 														) : pharmacyId === 865 && item.name === 'Incoming Orders' ? (
// 															<>Incoming Orders</>
// 														) : pharmacyId !== 865 && item.name === 'Incoming Orders' ? (
// 															'All Orders'
// 														) : item.name === 'Actions' ? (
// 															<>
// 																Actions
// 															</>
// 														) : (
// 															item.name
// 														)
// 													}
// 												</p>
// 											</div>
// 										</button>
// 									}
// 								</React.Fragment>
// 							))}
// 						</div>
// 					</div>
// 				</div>
// 			)
// 			}

// 			{/* <Navbar /> */}

// 		</div >
// 	);
// };

// export default DropdownMenu;

// Backup Code
